module.exports = __webpack_public_path__ + "img/whatsapp_grey.4646e0ab.png";